import { DashboardCanvas } from "../../components/DashboardCanvas";

export function TrainerSummary() {
  return <DashboardCanvas title="สรุปข้อมูลเทรนเนอร์" type="trainer" />;
}
